<button
  class="no-style help-menu-toggle"
  (click)="toggleMenu()">
  <mat-icon svgIcon="help_icon"></mat-icon>
  <p
    class="text bold"
    [matBadge]="totalNewFlags"
    [matBadgeHidden]="totalNewFlags === 0"
    [matBadgeOverlap]="true">
    {{ 'header.help-menu.header' | translate }}
  </p>
</button>

@if (isHelpMenuVisible) {
  <div
    class="help-menu"
    animate.enter="slide-in"
    animate.leave="slide-out">
    <coin-siemens-energy-faq-menu
      [helpData]="helpData[languageSelected]"
      [isLoading]="isHelpDataLoading"
      [isSearchBarVisible]="false"
      (close)="toggleMenu()"
      (openOtherTopic)="onOpenOtherFaqTopic($event)">
      @if (isSeomDownloadActive) {
        <div class="seom-download-container">
          <coin-v2-button
            type="secondary"
            icon="download"
            [text]="'header.help-menu.seom-download' | translate"
            (click)="downloadSeomStructureList()"></coin-v2-button>
        </div>
      }
    </coin-siemens-energy-faq-menu>
  </div>
}
